/** QL-13 — the quiz question dialog. */
export const T = {
  en_GB: {
    addQuestion: "Add question",
    editQuestion: "Edit question",
    questionLabel: "Question",
    questionPlaceholder: "What does diversification reduce?",
    options: "Answer options",
    optionsHelp:
      "Score each option. The client's summed score across the drawn questions decides the pass.",
    optionPlaceholder: "Answer text",
    addOption: "Add option",
    score: "Score",
    category: "Category",
    categoryNone: "None",
    categoryHint: "Groups questions for the draw. Never shown to the person taking the quiz.",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
  },
  nb_NO: {
    addQuestion: "Legg til spørsmål",
    editQuestion: "Rediger spørsmål",
    questionLabel: "Spørsmål",
    questionPlaceholder: "Hva reduserer diversifisering?",
    options: "Svaralternativer",
    optionsHelp:
      "Gi hvert alternativ en poengsum. Summen for de trukne spørsmålene avgjør om kunden består.",
    optionPlaceholder: "Svartekst",
    addOption: "Legg til alternativ",
    score: "Poeng",
    category: "Kategori",
    categoryNone: "Ingen",
    categoryHint: "Grupperer spørsmål for trekningen. Vises aldri til den som tar quizen.",
    cancel: "Avbryt",
    save: "Lagre",
    delete: "Slett",
  },
} as const;
